import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
  TextField,
  InputAdornment,
  TablePagination,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Notify from "src/notification/Notify";
import IsMountedRef from "src/utils/IsMountedRef";

const SalesPackages = () => {
  const mounted = IsMountedRef();
  const { management_id } = useParams();
  const [list, setList] = useState({ data: [], ready: false });

  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);

  const type = "packages";
  let total = 0;

  const handleChangePage = (event, newPage) => {
    event.persist();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const getPackagesSales = React.useCallback(async () => {
    let response = await axios.get("accounting/branch/sales", {
      params: {
        type: type,
        management_id: management_id,
      },
    });

    const data = response.data;
    if (mounted.current) {
      setList({ data: data, ready: true });
    }
  }, [mounted, management_id, type]);

  const calculateTotal = (srp) => {
    total += parseFloat(srp);

    return Notify.convertToNumber(srp);
  };

  useEffect(() => {
    getPackagesSales();
  }, [getPackagesSales]);

  const searchable = list.data.filter((data) => {
    return (
      data.bill_name.toLowerCase().indexOf(search.trim().toLowerCase()) !== -1
    );
  });

  return (
    <Paper>
      <Box p={2}>
        <Box display="flex">
          <Box flexGrow={1} />
          <Box>
            <TextField
              label="Search item"
              variant="outlined"
              fullWidth
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell> Date </TableCell>
                <TableCell> Type </TableCell>
                <TableCell> Bill </TableCell>
                <TableCell> Amount </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {list.ready ? (
                searchable.length > 0 ? (
                  searchable
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((data, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          {Notify.createdAt(data.created_at)}
                        </TableCell>
                        <TableCell> {data.bill_department} </TableCell>
                        <TableCell> {data.bill_name} </TableCell>
                        <TableCell align="right">
                          {calculateTotal(data.bill_amount)}
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4}>
                      <Typography color="secondary">
                        No record found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>
                    <Typography color="primary">
                      loading, please wait...
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TableCell colSpan={2}> </TableCell>
                <TableCell> Total </TableCell>
                <TableCell align="right">
                  {Notify.convertToNumber(total)}
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>

          <TablePagination
            component="div"
            count={searchable.length}
            rowsPerPageOptions={[10, 50, 100]}
            page={page}
            onChangePage={handleChangePage}
            rowsPerPage={rowsPerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage="List"
          />
        </TableContainer>
      </Box>
    </Paper>
  );
};

export default SalesPackages;
